import { SEVERITY, type Severity } from '@soc/shared';
import type { CSSProperties } from 'react';

/** Re-export the single source of truth so components import from one place. */
export { SEVERITY };
export type { Severity };

export const sevColor = (s: Severity): string => SEVERITY[s].color;
export const sevGlow = (s: Severity): string => SEVERITY[s].glow;
export const sevChip = (s: Severity): string => SEVERITY[s].chip;

/** A glowing severity dot, as used in rule rows, the legend and summaries. */
export function dotStyle(s: Severity, size = 8): CSSProperties {
  return {
    width: size,
    height: size,
    borderRadius: '50%',
    flex: 'none',
    background: SEVERITY[s].color,
    boxShadow: `0 0 7px ${SEVERITY[s].glow}`,
  };
}
